import {  styled, } from '@mui/system';
import { Box, Link, Typography } from '@mui/material';

export const StyledLink = styled(Link)({
  display:'inline-flex',
  alignItems:'center',
  color: '#121C2D',
  backgroundColor: '#fff',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 500,
  minHeight: 34,
  padding: '4px 16px',
  border: '1px solid #8891AA',
  borderRadius: '100px', 
  '&:not(:last-child)':{
    marginRight: 6
  },
  '&:hover': { 
    color:'#030B5D',
    borderColor:'#030B5D',
    backgroundColor:'#CCE4FF',
  },
  '&.selected': { 
    color:'#030B5D',
    borderColor:'#030B5D',
    backgroundColor:'#CCE4FF',
  },
});


export const TicketCustomer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  margin: theme.spacing(-2.5 , -3.75, 2.5 , -3.75), 
  padding: theme.spacing(1.25 , 3.75),
  backgroundColor: '#E5EBF8',
}));

export const TicketReply = styled(Box)(({  }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  // alignItems: 'flex-start',
}));
// LEFT PANEL
export const TicketReplyLeftPanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow:'column',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.background.default,
  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.13)',
  borderRadius: 10,
  padding: theme.spacing(2),
  width: 228,
  minHeight: '100%',
}));

export const TicketCustomerBox = styled(Box)({
  display: 'inline-flex',
  flexWrap: 'wrap',
  // alignItems: 'center',
  boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.15)',
  backgroundColor: '#fff',
  borderRadius: 3,
  minHeight: 34,
});
export const TicketCustomerTxt = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  backgroundColor: '#002f73',
  color:'#fff',
  fontSize: 14,
  lineHeight: '16px',
  minHeight: '100%',
  padding: theme.spacing(0.5, 2),
  borderRadius: '3px 0 0 3px',
}));

export const TicketCustomerInfo = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  minHeight: '100%',
  border: '1px solid #002f73',
  borderRadius: '0 3px 3px 0',
  padding: theme.spacing(0.5, 2),
  '& .MuiChip-sizeSmall':{
    minHeight: 21,
    height:'auto',
  }
}));

export const TicketCustomerInfoTxt = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  color:'#000',
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 500,
  '&:not(:first-of-type)':{
    marginLeft: theme.spacing(1.25),
  }
}));


// RIGHT PANEL
export const TicketReplyRightPanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow:'column',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.background.default,
  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.13)',
  borderRadius: 10,
  padding: 0,
  width: 228,
  minHeight: '100%',
  overflow: 'auto',
  '& .MuiAccordion-root':{
    boxShadow: 'none',
    width: '100%',
    margin: '0 !important',
    // paddingBottom: theme.spacing(2),
    '&:not(:last-child)':{
      borderBottom: '1px solid #E8E8E8',
    },
    '&:first-of-type':{
      '& .MuiAccordion-heading':{      
        '& .MuiButtonBase-root':{
          borderRadius: '10px 10px 0 0',
        },
      } 
    },
    '& .MuiAccordion-heading':{  
      position: 'sticky',
      top: 0,
      zIndex: 1,    
      '& .MuiButtonBase-root':{       
        backgroundColor: '#fff', 
        minHeight: '52px !important',
        borderBottom: '1px solid #E8E8E8',        
        '& .MuiAccordionSummary-content':{
          margin: 0,
          '& .MuiTypography-root':{
            color: '#222',
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 600,
          }
        }
      }
    },
    '& .MuiAccordionDetails-root':{
      padding: theme.spacing(2),
    },
  }
}));

export const UserBox = styled(Box)(({  }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
}));

export const AvatarWrapper = styled(Box)(({  }) => ({
  borderRadius: '100px',
}));

export const UserInfoBox = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  paddingLeft: theme.spacing(1.75),
}));

export const UserNameTypography = styled(Typography)(({  }) => ({
  display: 'block',
  color: '#3F3F44',
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 600,
}));

export const UserRoleTypography = styled(Typography)(({  }) => ({
  display: 'block',
  color: '#3F3F44',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
}));

export const UserInfos = styled(Box)(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(2.5),
}));
export const UserInfoTl = styled(Typography)(({ }) => ({
  display: 'block',
  color: '#828282',
  fontSize: '13px',
  lineHeight: '15px',
  fontWeight: 400,
}));
export const UserInfoDesc = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: '#2A2A2A',
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 500,
  wordWrap: 'break-word',
  marginTop: theme.spacing(0.75),
}));

export const TicketBox = styled(Box)(({ theme }) => ({
  display: 'block',
  margin: theme.spacing(-2, -2, 0, -2),
  padding: theme.spacing(2.5, 2),
  backgroundColor: "#FFFBD1",
}));

export const TicketNo = styled(Typography)(({  }) => ({
  display: 'block',
  color: '#002F73',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 400,
}));

export const TicketCard = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: '#222',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 500,
  marginTop: theme.spacing(0.75),
}));

export const TicketCreate = styled(Box)(({ theme }) => ({
  display: 'block',
  color: '#6E7177',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 500,
  marginTop: theme.spacing(0.75),
  '& .MuiTypography-root':{
    color: '#6E7177',
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 400,
  }
}));

export const TicketStatus = styled(Box)(({ theme }) => ({
  display: 'block',
  color: '#6E7177',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 500,
  marginTop: theme.spacing(0.75),
  '& .MuiTypography-root':{
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 400,
  }
}));


export const TicketDataBox = styled(Box)(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(2, 0),
  '&:last-child':{
    paddingBottom: 0,
  },
  '&:not(:last-child)':{
    borderBottom: '1px solid #E8E8E8',
  },
  '& .ticketContent':{
    color:'#323232',
    fontSize: 14,
    lineHeight: '20px',
    marginTop: theme.spacing(1.5),
  }
}));

export const TicketDataTime = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap:'wrap',
  alignItems:'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(0.75),
  '& .MuiTypography-root':{
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 400,
  },
  '& .MuiLink-root':{
    cursor: 'pointer !important',
    opacity: '0',
    '&:hover':{
      textDecoration: 'none',
    }
  }
}));
 
// MIDDLE PANEL

export const TicketReplyMiddlePanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow:'column',
  alignItems: 'flex-start',
  width: 'calc(100% - (228px * 2))',
  flex: '1',
  padding: theme.spacing(0,2),
}));

export const TicketReplyMiddleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow:'column',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.background.default,
  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.13)',
  borderRadius: 10,
  padding: 0,
  width: '100%',
  // minHeight: '100%',
  '&:not(:last-child)':{
    marginBottom: theme.spacing(2),
  },
  '&.with-gap':{
    padding: theme.spacing(2),
  },
}));


export const ChatboxHeader = styled(Box)(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(2.5, 2.75),
  borderBottom: '1px solid #E8E8E8',
  width: '100%',
  '& h2':{
    color: '#242424',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 500,
  },
  '& p':{
    color:'#4D4D4D',
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 400,
    marginTop: theme.spacing(1.25),
    '& a':{
      TextDecoration: 'none !important',
    }    
  }
}));

export const ChatboxBody = styled(Box)(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(2, 2.75),
  borderBottom: '1px solid #E8E8E8',
  width: '100%',
  height: 426,
  overflow: 'auto',
}));

export const ChatList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  '&:not(:first-of-type)':{
    marginTop: theme.spacing(2.5),
  },
  '&.right':{
    flexFlow: 'row-reverse',
    '& .right-data':{
      alignItems: 'flex-end',
      paddingRight: theme.spacing(1.5),
      paddingLeft: 0,
    },
  },
}));

export const ChatListDataContainer = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  flexFlow: 'column',
  alignItems: 'flex-start',
  paddingLeft: theme.spacing(1.5),
  maxWidth: 'calc(100% - 88px)',
  flex: 1,
}));

export const ChatUserNameData = styled(Box)(({  }) => ({
  display: 'inline-flex',
  alignItems: 'center',  
}));

export const ChatUserNameTypography = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  color: theme.palette.primary.main,
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 600,
}));

export const ChatTimeTypography = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  color: '#5F5F5F',
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 500,
  marginLeft: theme.spacing(1.5),
  paddingLeft: theme.spacing(2.5),
  position: 'relative',
  '&:before':{
    content: '""',
    display:'block',
    width: 7,
    height: 7,
    backgroundColor: '#CBCBCB',
    borderRadius: 100,
    position: 'absolute',
    top: 6,
    left: 0,
  }
}));


export const ChatMessageBox = styled(Box)(({ theme }) => ({
  display: 'block',
  backgroundColor: '#F4F8FF',
  padding: theme.spacing(2.5),
  borderRadius: 10,
  marginTop: theme.spacing(1.5),
  '& .MuiTypography-root':{
    color: '#000',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
  }
}));


export const ChatboxReply = styled(Box)(({  }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
}));

export const ChatboxReplyHead = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  backgroundColor: '#E7E7E7',
  padding: theme.spacing(1.75, 2.5),
  borderBottom: '1px solid #E8E8E8',
  '& .MuiFormControl-root':{
    display: 'inline-block',
    width: 70,
    marginLeft: theme.spacing(1),
    // marginLeft: theme.spacing(2.5),
    '&.v2 .MuiFormLabel-root + .MuiInputBase-root':{
      background: 'transparent',
      border: 'none',
      '& .MuiInputBase-input':{
        background: 'transparent',
        border: 'none',
        padding: '0 !important',
        minHeight: '28px !important',
      },
      '& fieldset':{
        opacity: '0',
      }
    },
    '& .MuiOutlinedInput-root':{
      width: '100%',
      margin: 0,
    },
  },
}));

export const ChatheadEmail = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  color:'#858585',
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 400,
  position:'relative',
  '&:not(.noGap)':{
    paddingLeft: theme.spacing(2.5),
    marginLeft: theme.spacing(1.25),
    '&:before':{
      content: '""',
      width: 2,
      height: 17,
      borderLeft: '1px solid #CECECE',
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
  '& .MuiTypography-root':{
    color: '#000',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    marginLeft: theme.spacing(0.5),
  }
}));

export const ChatHeadBottom = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  backgroundColor: '#fff',
  padding: theme.spacing(1.75, 2.5),
  borderBottom: '1px solid #E8E8E8',
  '& .MuiLink-root':{
    marginLeft: theme.spacing('auto'),
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    '&:hover':{
      textDecoration: 'underline',
    }
  }
}));

export const ReplyTextarea = styled(Box)(({  }) => ({
  display: 'block',
  width: '100%',
  // borderBottom: '1px solid #E8E8E8',
  '& .MuiOutlinedInput-root':{
    margin: '0 !important',
    borderRadius: '0 !important',
    '& .MuiInputBase-inputMultiline':{
      height: '160px !important',
      padding: '0 !important',
      backgroundColor: 'transparent',
    },
    '& fieldset':{
      opacity: '0',
    }
  }
}));

export const ChatboxReplyFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(2, 2.5),
  borderTop: '1px solid #E8E8E8',
}));

export const ChatReplyOptions = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  paddingRight: theme.spacing(2),
}));

export const ChatOption = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  textDecoration: 'none',
  '&:not(:last-child)':{
    marginRight: theme.spacing(1),
  },
  '& img':{
    display: 'block',
    width: 34,
    height: 'auto',
  },
}));

export const Buttonset = styled(Box)(({  }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
}));

export const ChatAttachments = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  margin: theme.spacing(-0.5),
}));

export const ChatAttachmentCol = styled(Box)(({ theme }) => ({
  display: 'flex',
  float: 'left',
  justifyContent: 'center',
  alignItems: 'center',
  width: 72,
  height: 72,
  margin: theme.spacing(0.25),
  backgroundColor: '#fff',
  border: '1px solid #485052',
  borderRadius: 8,  
  cursor:'pointer',
  position: 'relative',
  overflow: 'hidden',
  '&:before':{
    content:'""',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'absolute',
    top: 0,
    left: 0,
    transition: '500ms',
    opacity: '0',
    visibility: 'hidden',
  },
  '&:hover:before':{
    opacity: '1',
    visibility: 'visible',
  },
  '& img':{
    display: 'block',
    width: 'auto',
    maxWidth: '100%',
    height: 'auto',
    maxHeight: '100%',
    '&.icon':{
      maxWidth: '36px',
      maxHeight: '36px',
    }
  },
}));

export const ChatAttachmentCount = styled(Box)(({  }) => ({
  display: 'flex',
  float: 'left',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.6)',
  color: '#fff',
  fontSize: '20px',
  fontWeight: 500,
}));

export const ChatAttachmentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  margin: theme.spacing(-1.25),
}));

export const ConfirmationDialogTl = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  '& strong':{
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}));

